"use client";

import { useEffect } from "react";

import { BrandText } from "@/components/brand-text";
import { oswald } from "@/styles/fonts";
import { cn } from "@/utils/cn";

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error(error);
  }, [error]);

  return (
    <main className="container">
      <div className={cn("flex flex-col gap-10 py-20 md:py-24")}>
        <h1
          className={cn(
            "text-4xl text-royal-500 dark:text-gold-500",
            oswald.className,
          )}
        >
          Something went wrong!
        </h1>

        <p className="text-neutral-600 dark:text-neutral-400">
          Sorry, there was an error. Please{" "}
          <BrandText onClick={() => reset()} className="cursor-pointer">
            try again
          </BrandText>
          , or go back to the{" "}
          <BrandText
            onClick={() => (window.location.href = "/")}
            className="cursor-pointer"
          >
            homepage
          </BrandText>
          .
        </p>
      </div>
    </main>
  );
}
